"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestnetConsensusConfig = void 0;
const TestnetConsensusConfig = {
    consensusAppId: 730430673,
    xAlgoId: 730430700,
    stakeAndDepositAppId: 731190793,
};
exports.TestnetConsensusConfig = TestnetConsensusConfig;
//# sourceMappingURL=testnet-constants.js.map